import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { NO_OF_PROERTIES_PER_PAGE_IN_LISTING_PAGE } from "@/constant";
import { useAppSelector } from "stores/hooks";
import { DateRangeDataType, GuestDetailsType, LocationDataType } from "stores/local-search/types";
import { markSearch, selectSearchQuery } from "stores/search/searchSlice";
import { dashedToCommaSeparatedName } from "utils/url";
export type LocalSearchType = LocationDataType & DateRangeDataType & GuestDetailsType;
export const useMarkSearchUpdate = () => {
  const dispatch = useDispatch();
  const searchQuery = useAppSelector(selectSearchQuery);
  return useCallback((localSearch: LocalSearchType) => {
    dispatch(markSearch({
      page: localSearch.page,
      lat: localSearch.lat,
      lng: localSearch.lng,
      bounds: localSearch.bounds || null,
      shortName: dashedToCommaSeparatedName(localSearch.shortName || ""),
      longName: dashedToCommaSeparatedName(localSearch.longName || ""),
      placeId: localSearch.placeId || "",
      placeType: localSearch.placeType || "",
      startDate: localSearch.startDate || null,
      endDate: localSearch.endDate || null,
      noOfDays: localSearch.noOfDays,
      adultCount: localSearch.adultCount,
      childrenCount: localSearch.childrenCount,
      petAllowed: localSearch.petAllowed,
      isSearchingInMap: localSearch.isSearchingInMap,
      numberOfGuest: (localSearch?.adultCount || 0) + (localSearch?.childrenCount || 0),
      Location: localSearch.Location,
      childAllowed: localSearch.childAllowed || localSearch.suitableChild,
      sortBy: "highToLow",
      propertyConfigTypeId: localSearch.propertyConfigTypeId || null,
      isBoundaryVisible: localSearch.isBoundaryVisible || false,
      isBoundaryAutoRemoved: false,
      limit: NO_OF_PROERTIES_PER_PAGE_IN_LISTING_PAGE,
      ...(searchQuery?.nearByProperties ? {
        nearByProperties: false
      } : {})
    }));
  }, [dispatch, searchQuery?.nearByProperties]);
};